import Box from "@material-ui/core/Box";
import React, { useState } from "react";
import { useLocalStorage } from "src/utils/use-local-storage";
import CustomTabs from "./custom-tabs";
import InputCheckBox from "./input-checkbox";
import TabPanel from "./tab-panel";
import { ArrowLeftIcon, ArrowRightIcon } from "./icons-svg";

export default function AuditProcess(props) {
  var number=1;
  const [showTaskTabs, setShowTaskTabs] = useLocalStorage('showTaskTabs', true);
  
  const [activeTab, setActiveTab] = useState(0);

  const getTabs = () => {
    let tabs = [];
    tabs = props.auditProcess.tasks.map((task,idx)=>{
      return {
          label: task.category,
          disabled: false
      }
    });
    return tabs;
  }

  const onTabChange = (value) => {
    setActiveTab(value);
  }

    return(
        <>
          <Box
            style={{ flexGrow: 1, display: 'flex', height: '90vh'}}
          >
          <CustomTabs 
          tabs={getTabs()} 
          value={activeTab} 
          onTabChange={(event, value) => onTabChange(value)} 
          orientation="vertical"
          showTabs={showTaskTabs}
          >
          <div css={`
              display: flex;
              justify-content: right;`
              }>
                {
                  showTaskTabs ?
                    <span css={`
                      color:#799fd4;
                      cursor: pointer;
                      text-decoration-line: underline;
                  `}
                      onClick={() => { setShowTaskTabs(false) }}>{ArrowLeftIcon}</span>
                    :
                    <span css={`
                      color:#799fd4;
                      cursor: pointer;
                      text-decoration-line: underline;
                  `}
                      onClick={() => { setShowTaskTabs(true) }}>{ArrowRightIcon}</span>
                }
            </div>
            <div style={{width: "80%", overflowY: 'auto'}}>
              {
                props.auditProcess.tasks.length ? 
                props.auditProcess.tasks.map((task, id) => {
                  return (
                    <TabPanel value={activeTab} index={id} key={id}>
                      <div>
                        {task.description ? 
                            task.description.split('\n').map((desc, idx)=>
                            (<p key={idx}>{desc}</p>)
                            )
                          : null
                        }
                      </div>

                      {
                      (
                        task.subtasks && task.subtasks.length) ?
                        task.subtasks.map((subtask,index)=> (
                          <div key={index}>
                              <InputCheckBox
                                checked={props.completedTasks[subtask.id]} 
                                onChange={(value) => props.setCompletedTask(subtask.id, value)}
                                label={`${number++}. ${subtask.title}`}
                              />
                          </div>
                        )) : null
                      }
                    </TabPanel>
                  )
                }):null
              }
            </div>
          </CustomTabs>
          </Box>
        </>
    )
}